import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function ShortTextProperties({ question }) {
  return <QuestionLabel question={question} />
}